import downloadCenterAndAfk_component from '#BASE/components/downLoad/DownLoadCenterAndAFK';
import loginEntryDownload from 'TY/components/Download/loginEntryDownload.component';

export default {
    mixins: [loginEntryDownload, downloadCenterAndAfk_component],
    data: function () {
        return {
            selectedClientUrl: '',
            selectedHangingUrl: '',
            selectedLegendUrl: '',
        };
    },
    computed: {
        currentClientUrl: {
            get() {
                return this.selectedClientUrl || this.iosUrl || this.androidUrl || this.LoginUrl;
            },
            set(newValue) {
                this.selectedClientUrl = newValue;
            },
        },
        currentHangingUrl: {
            get() {
                return this.selectedHangingUrl || this.AFKiosUrl || this.AFKAndroidUrl || this.AFKPcUrl;
            },
            set(newValue) {
                this.selectedHangingUrl = newValue;
            },
        },
        currentLegendUrl: {
            get() {
                return this.selectedLegendUrl || this.LegendAFKiosUrl || this.LegendAFKAndroidUrl || this.LegendAFKPCUrl;
            },
            set(newValue) {
                this.selectedLegendUrl = newValue;
            },
        },
    },
    methods: {
        copyLink(url) {
            let _this = this;
            _this.$copyText(url).then(() => {
                _this.$dialog.warning("已复制鏈接: " + url);
            }, () => {
                console.log("复制失败");
            });
        },
        changeUrl(url, type) {
            if (type === 'client') {
                this.currentClientUrl = url;
            } else if (type === 'hanging') {
                this.selectedHangingUrl = url;
            } else if (type === 'legend') {
                this.selectedLegendUrl = url;
            }
        }
    }
}